import { HttpClient } from '@angular/common/http';
import { Component, ElementRef, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Px2RemService } from 'src/app/services/px2-rem.service';

@Component({
  selector: 'svg-icon',
  templateUrl: './svg-icon.component.html',
  styleUrls: ['./svg-icon.component.less'],
})
export class SvgIconComponent implements OnInit {
  @Input() iconName: string = '';
  @Input() size: number = 24;
  @Input() isUrl: Boolean = true;
  contentUrl: string = '';

  svgIcon: SafeHtml = '';

  constructor(private http: HttpClient, private sanitizer: DomSanitizer,private px2RemService:Px2RemService) {}

  ngOnInit() {
    this.loadSvgIcon();
  }

  loadSvgIcon() {
   if(this.isUrl){
    this.contentUrl = `url('assets/${this.iconName}')`
    return;
   }
    this.http.get(`assets/${this.iconName}`, { responseType: 'text' })
      .subscribe((data:any) => {
        // 使用 DomSanitizer 进行安全转换
        const safeSvg = this.sanitizer.bypassSecurityTrustHtml(data);
       
        this.svgIcon = safeSvg;
      });
  }
  convertPxToRem(px: number): string {
    return px+'px';
  }
}
